export const LOGO_PATH = '/' + process.env.VUE_APP_SYSTEM_LOGO
export const SYSTEM_BRAND = process.env.VUE_APP_SYSTEM_BRAND_SHRTCT
export const SYSTEM_NAME = process.env.VUE_APP_SYSTEM_NAME

export const API_URL = process.env.VUE_APP_API_URL;
export const BASE_URL = process.env.VUE_APP_BASE_URL;

export const REMOTE_URL = process.env.VUE_APP_REMOTE_URL;

export const TOKEN_VARIABLE = "cnc_acctg_token";
export const EXPIRY_TOKEN_VARIABLE = "cnc_acctg_token_expiry";
export const USER_INFO_VARIABLE = "cnc_acctg_user_info";

export const SALUTATIONS = {
    mr: 'Mr',
    ms: 'Ms',
    mrs: 'Mrs',
    dr: 'Dr'
}

export const FIELD_STATUS_BOOTSTRAP = {
    0: "",
    1: "is-valid",
    2: "is-invalid"
}

export const ACC_TYPES = {
    asset: 'Assets',
    liability: 'Liabilities',
    equity: 'Equity',
    income: 'Income',
    expense: 'Expense'
}

export const TRANSACTION_STATUSES = {
    draft: 'Draft',
    posted: 'Posted'
}

export const ERROR_MESSAGES = {
    fields_format: 'Please fill in required fields.',
    entry_count: 'Entries cannot be empty. Please add entries.',
    item_count: 'Items cannot be empty. Please add items.',
    entry_amount: 'Amount must not be less than 0.',
    entries_variance: 'Cannot proceed to save journal. Unbalanced journal cannot be recorded.'
}

export const MODULES = {
    payable: 'Payable',
    receivable: 'Receivable',
    disbursement: 'Payment',
    receipt: 'Receipt',
}

export const TRANSACTION_TYPES = {
    payable: 'To pay for',
    receivable: 'To receive from',
    disbursement: 'Purchase of',
    receipt: 'Payment of',
}

export const SYS_COMPONENTS = {
    acctg_sys: 'Accounting System',
    opt_sys: 'Operations System',
    accounting: 'Accounting',
    journal: 'Journal',
    payables: 'Payables',
    modules: 'Modules',
    pages: 'Modules',
    reports: 'Reports',
    setup: 'Setup'
}

export const ROUTES_PARENT= {
    pages: ['transactions', 'salesTransaction', 'stocks', 'waste', 'pettyCash'],
    reports: ['sales', 'inventory', 'transactionReports', 'dailyReports'],
    setup: ['suppliers', 'suppliesCategory', 'supplyTypes', 'items', 'itemRecipes', 'users']
}

export const ROUTES_EQUIVALENT_PERM_CODE = {
    transactions: 'transactions',
    salesTransaction: 'sales_transactions',
    pettyCash: 'petty_cash',
    stocks: 'stocks',
    waste: 'waste',
    sales: 'sales',
    inventory: 'inventory',
    transactionReports: 'transactions_report',
    dailyReports: 'daily',
    suppliers: 'entities',
    suppliesCategory: 'supply_category',
    supplyTypes: 'supply_types',
    items: 'items',
    itemRecipes: 'recipe',
    users: 'users',
}